import React from "react";
import { createPortal } from "react-dom";
import "./Loader.scss";

const Loader = () => {
  const overlay = (
    <div className="loader-overlay" role="status" aria-live="polite" aria-busy="true">
      <span className="loader-15" aria-hidden />
    </div>
  );

  if (typeof document !== "undefined") {
    return createPortal(overlay, document.body);
  }

  return overlay;
};

export default Loader;
